import React, { useEffect, createElement } from 'react';
interface SEOProps {
  title: string;
  description: string;
  canonical?: string;
}
export function SEO({
  title,
  description,
  canonical = 'https://dataprixa.com'
}: SEOProps) {
  useEffect(() => {
    // Update Title
    document.title = title;
    // Helper to update or create meta tags
    const updateMeta = (name: string, content: string) => {
      let element = document.querySelector(`meta[name="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('name', name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };
    // Helper for OG tags (property instead of name)
    const updateOg = (property: string, content: string) => {
      let element = document.querySelector(`meta[property="${property}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('property', property);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };
    updateMeta('description', description);
    updateOg('og:title', title);
    updateOg('og:description', description);
    updateOg('og:url', canonical);
    updateOg('og:type', 'website');
    // Add canonical link
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonical);
  }, [title, description, canonical]);
  return null;
}